import {
  ActionIcon,
  CopyButton,
  Group,
  rem,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { useMemo } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useProfileStore, useSessionStore } from "../../../../stores/UserStore";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { appHost } from "../../../../functions/appHost";

const AffiliationLink = () => {
  const lang = useLanguage((s) => s.language);

  const profile = useProfileStore((s) => s.profile);
  const reseller = useSessionStore((s) => s.reseller);

  const value = useMemo(() => {
    return `https://${appHost(reseller)}/signup?ref=${profile.id}`;
  }, [profile, reseller]);

  return (
    <Group>
      <Text fw={500}>{lang.referral.your_link} :</Text>

      <TextInput
        size="md"
        value={value}
        w={450}
        rightSectionWidth={42}
        rightSection={
          <CopyButton value={value}>
            {({ copied, copy }) => (
              <Tooltip
                label={copied ? lang.referral.copied : lang.referral.copy}
                color={copied ? "teal" : "black"}
              >
                <ActionIcon
                  color={copied ? "teal" : "primary"}
                  size={32}
                  radius="md"
                  variant="filled"
                  onClick={copy}
                >
                  {copied ? (
                    <IconCheck
                      style={{ width: rem(18), height: rem(18) }}
                      stroke={1.5}
                    />
                  ) : (
                    <IconCopy
                      style={{ width: rem(18), height: rem(18) }}
                      stroke={1.5}
                    />
                  )}
                </ActionIcon>
              </Tooltip>
            )}
          </CopyButton>
        }
      />
    </Group>
  );
};

export default AffiliationLink;
